import * as React from "react";
import { connect } from 'react-redux';
import { ApplicationState } from '../../../store/index';
import { ProfileSelectionModal, ProfileSelectionCallbacks, ProfileSelectionModalProps } from '../../profile/selectionmodal/selectionmodal';
import _ from "underscore";
import { ProfileList, ProfileListProps } from "../../profile/profilelist";
import { actionCreator as profileAction } from "../../../store/profile/ProfilesSate";
import { actionCreator, actionsMiddleware } from "../../../store/events/EventState";

const mapStateToPropProfileEvent = (state: ApplicationState): ProfileListProps => {

    return {
        hasNextPage: false,
        list: state.profiles.profilesList,
        selectionEnabled: true,
        selectedProfiles: state.events.eventProfiles
    }
}

const mapDispatchPropProfileEvent = (dispatch) => {
    return {
        onRowClick: (id: string) => dispatch(actionsMiddleware.setSelectedProfiles(id)),
        onUnload: () => { }
    };
}

export const ConnectedProfileListEvent = connect<ProfileListProps>(mapStateToPropProfileEvent, mapDispatchPropProfileEvent)(ProfileList);

const mapStateToProsp = (state: ApplicationState): ProfileSelectionModalProps => {
    
    return {
        isModalOpen: state.events.eventProfilesModalOpened,
        selectedProfiles: state.events.eventProfiles,
        profileList: <ConnectedProfileListEvent />
    }
}

const mapDispatchToProps = (dispatch) => (dispatch): ProfileSelectionCallbacks => {
    return {
        onConfirm: () => dispatch(actionsMiddleware.saveEventProfiles()),
        toogleModal: () => dispatch(actionCreator.toggleEventProfilesModal()),
        onRemoveSelected: (id: string) => dispatch(actionsMiddleware.setSelectedProfiles(id))
    };
}

export const ConnectedProfileEventSelectionModal = connect<ProfileSelectionModalProps, ProfileSelectionCallbacks>(mapStateToProsp, mapDispatchToProps)(ProfileSelectionModal);